import React from 'react';
import { formatFileSize } from 'helpers/formatNumber';
import { IconRemove } from 'icons';
import MediaUploadModalThumbnail from './MediaUploadModalThumbnail';

interface Props {
  file: File;
  onRemove: () => void;
}

export default function MediaUploadModalStagedFileRow(props: Props) {
  const { file, onRemove } = props;

  return (
    <div className="mb-2 flex items-center">
      <div className="mr-2">
        <MediaUploadModalThumbnail
          contentType={file.type}
          filename={file.name}
          previewUrl={URL.createObjectURL(file)}
        />
      </div>

      <div className="mr-3 flex-1 truncate text-left text-16 text-dark">
        {file.name}
      </div>

      <div className="flex flex-shrink-0 items-center justify-end text-16">
        {formatFileSize(file.size)}

        <button type="button" className="ml-1 h-2 w-2" onClick={onRemove}>
          <IconRemove className="h-full w-full text-grey6 hover:text-grey5" />
        </button>
      </div>
    </div>
  );
}
